import { isIOS, isAndroid } from '../device';

import { observeViewportResize } from './observeViewportResize';

function observeToolbarHide() {
  if (isIOS || isAndroid) {
    const initialViewportHeight = window.innerHeight;

    const { stopObserving } = observeViewportResize(() => {
      const viewportHeight = window.innerHeight;
      const body = document.body;

      const prefix = isIOS ? 'ios' : 'android';

      // the viewport height becomes bigger when the iOS bottom menu or android's search bar is hidden
      if (viewportHeight > initialViewportHeight) {
        const toolbarHeight = viewportHeight - initialViewportHeight;
        const toolbarVersionClassname =
          toolbarHeight > 100
            ? `${prefix}-toolbar-tall`
            : `${prefix}-toolbar-short`;
        body.classList.add(`${prefix}-toolbar-hide`);
        body.classList.add(toolbarVersionClassname);
      } else {
        body.classList.remove(`${prefix}-toolbar-hide`);
      }
    });

    return () => stopObserving();
  }
}

export { observeToolbarHide };
